import styled from 'styled-components';
import { Flex } from 'components/UI/Flex';

export const CheckboxContainer = styled.div``;

export const FormContainer = styled(Flex)`
	height: 100%;
`;
